import { render, staticRenderFns } from "./NewNip.vue?vue&type=template&id=1a235d68&scoped=true"
import script from "./NewNip.vue?vue&type=script&lang=js"
export * from "./NewNip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a235d68",
  null
  
)

export default component.exports